import { Card, message, Radio, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useSession } from "../../../util/Session";
import { apiCall } from "../../utilities/Api";

export default function MultipleShipments(props) {

    const [session, setSession] = useSession();
    const { batch, updateBatch = () => { }, provider = "", address_id = "", guest_address_json = "", delivery_preference = "", active = false, delivery_min = "", delivery_max = "", saved = {} } = props;
    const [results, setResults] = useState([])
    const eta = ((delivery_min && delivery_max && (delivery_min !== "0" && delivery_max !== "0"))) ? <strong> ({delivery_min} - {delivery_max}) business days ETA</strong> : <></>;

    const setShipping = (_batch = "all", _provider = provider) => {

    

        let obj = {
            delivery_preference: delivery_preference,
            address_id: address_id,
            guest_address_json : guest_address_json,
            provider: _provider,
            multiship_method: _batch
        }

        apiCall("checkout/setShipping", obj, (_status, _result) => {
            if (_status) {
                setSession({ ...session, "cart": _result })
            } else {
                message.error(_result.error);
            }
        })
    }

    const fetchShippingBatch = () => {
        if (active) {

            let _address_id = (session.logged_in) ? address_id : "";
        
            apiCall("checkout/getShippingBatch", { delivery_preference: delivery_preference, provider: provider, address_id: _address_id, guest_address_json : guest_address_json }, (_status, _result) => {
                if (_status) {
                    setResults(_result);
                    setShipping("all", provider);
                }
            })
        }
    }

    const saveBatch = (e, _val) => {
        e.stopPropagation();
        e.preventDefault();
        updateBatch(_val);
        setShipping(_val);
    }

    useEffect(fetchShippingBatch, [active]);
    

    if (!Array.isArray(results) || results.length < 1) {
        return (<></>)
    }

    let _all = results.some(item => item.type === "batched");
    let _batched = results.findIndex(item => item.type === "batched");
    let _individual = results.findIndex(item => item.type === "individual");

    return (
        <>
            <Card onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} style={{ "border": "1px dashed #e70d3d" }}>
                <div style={{ "color": "#000", "fontSize": "16px" }}>Multiple Shipments</div>
                <div className="shim" />
                <strong style={{ "color": "#e70d3d" }}>Heads up! Some of the items in your cart need to be ordered{(_all) ? ", while others are in-stock and ready to ship" : ":"}</strong>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Space onClick={(e) => saveBatch(e, "all")}>
                    <Radio checked={(batch === "all")} />
                    <div style={{ "color": "#e70d3d", "width": "60px" }}><nobr>+ ${results[0]?.delta_cost || ""}</nobr></div>
                    <div style={{ "color": ((batch === "all")) ? "#000" : "inherit" }}>Ship everything once all items have arrived. - <em>1 shipment</em></div>
                </Space>
                <div className="shim" /><div className="shim" />

                {((_batched > -1) &&
                    <Space onClick={(e) => saveBatch(e, "batched")}>
                        <Radio checked={(batch === "batched")} />
                        <div style={{ "color": "#e70d3d", "width": "60px" }}><nobr>+ ${results[_batched]?.delta_cost || ""}</nobr></div>
                        <div style={{ "color": (batch === "batched") ? "#000" : "inherit" }}>{(_all) ? <>Ship what's in-stock now{eta}, and the rest once they are all in-stock.</> : <>Ship all at once when they are in-stock</>} - <em>2 shipments</em></div>
                    </Space>
                )}

                  {((_individual > -1) &&
                <Space onClick={(e) => saveBatch(e, "individual")}>
                    <Radio checked={(batch === "individual")} />
                    <div style={{ "color": "#e70d3d", "width": "60px" }}><nobr>+ ${results[_individual]?.delta_cost || ""}</nobr></div>
                    <div style={{ "color": (batch === "individual") ? "#000" : "inherit" }}>{(_all) ? <>Ship what's in-stock now{eta}, and the rest individually as they arrive.</> : <>Ship individually as they arrive.</>} - <em>{results?.[_individual]?.batches || ""} shipments</em></div>
                </Space>
                )}

            </Card>
        </>
    )
}